export default "<p>app-student-class works!</p>\n";